
/*
 * ------------------------------------------------------------------
 * MAIS validações adicionais de obrigatoriedade no envio (submit).
 *
 * Alterações :
 *  - submitForm(): passou a exigir o aceite dos Termos de Privacidade e
 *    Condições (campo `terms`). Como esse checkbox só é marcado através do
 *    modal de aceite, um usuário que pule o Passo 2 navegando pelas abas
 *    chega ao submit com ele desmarcado. Nesse caso, o envio é interrompido,
 *    o usuário é devolvido à aba "Seus Dados" (Passo 2) e o campo é
 *    sinalizado — impedindo o registro sem consentimento (LGPD).
 *
 * ------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', () => {
    
    // Set logo
    const logoEl = document.getElementById('brandLogo');
    const logoElFooter = document.getElementById('brandLogoFooter');
    if (logoEl && window.currentBrand.logoUrl) logoEl.src = window.currentBrand.logoUrl;
    if (logoElFooter && window.currentBrand.logoUrl) logoElFooter.src = window.currentBrand.logoUrl;

    // Set brand title
    document.title = `Registro de Produto | ${window.currentBrand.name}`;

    // Opt-in brand name
    const optInName = document.getElementById('optInBrandName');
    if (optInName) {
        optInName.textContent = window.currentBrand.name;
    }

    // Set EmbedSocial Ref
    // --- Estratégia de Carregamento Seguro ---
    const embedDiv = document.getElementById('embedSocialDiv');
    const socialKey = window.currentBrand?.embedSocialChave;

    if (embedDiv && socialKey) {
        embedDiv.setAttribute('data-ref', socialKey);

        const retryEmbedSocial = setInterval(() => {
            if (window.EmbedSocialHashtag) {
                window.EmbedSocialHashtag.init();
                clearInterval(retryEmbedSocial); 
            }
        }, 500);
        setTimeout(() => clearInterval(retryEmbedSocial), 10000);
    }

    // Setup gift radio toggle and child container visibility
    const giftRadios = document.querySelectorAll('input[name="is_gift"]');
    const knowsRadios = document.querySelectorAll('input[name="knows_child"]');
    const childContainer = document.getElementById('childInfoContainer');
    const knowsContainer = document.getElementById('knowsChildContainer');
    const childSectionTitle = document.getElementById('childSectionTitle');

    function evaluateChildVisibility() {
        const isGift = document.querySelector('input[name="is_gift"]:checked')?.value === 'yes';

        if (isGift) {
            knowsContainer?.classList.remove('hidden');
            const knows = document.querySelector('input[name="knows_child"]:checked')?.value === 'yes';
            if (childSectionTitle) childSectionTitle.textContent = "Dados da Criança Presenteada";
            if (knows) {
                childContainer?.classList.remove('hidden');
            } else {
                childContainer?.classList.add('hidden');
            }
        } else {
            // If not a gift, assume user has the child (themselves)
            knowsContainer?.classList.add('hidden');
            if (childSectionTitle) childSectionTitle.textContent = "Dados da Sua Criança";
            childContainer?.classList.remove('hidden');
        }
    }

    giftRadios.forEach(r => r.addEventListener('change', evaluateChildVisibility));
    if (knowsRadios) knowsRadios.forEach(r => r.addEventListener('change', evaluateChildVisibility));
    evaluateChildVisibility(); // Init

    // Add Another Child Logic
    const btnAddChild = document.getElementById('btnAddChild');
    const childrenList = document.getElementById('childrenList');
    if (btnAddChild && childrenList) {
        btnAddChild.addEventListener('click', () => {
            // Clone the first entry to keep structure intact
            const firstEntry = childrenList.querySelector('.child-entry');
            if (!firstEntry) return;
            const newEntry = firstEntry.cloneNode(true);

            // Clear values
            newEntry.querySelectorAll('input').forEach(input => input.value = '');
            newEntry.querySelectorAll('select').forEach(select => select.selectedIndex = 0);

            // Add remove button if not exists
            if (!newEntry.querySelector('.btn-remove-child')) {
                const removeBtn = document.createElement('button');
                removeBtn.type = 'button';
                removeBtn.className = 'btn-remove-child absolute -top-3 -right-3 bg-red-100 text-red-600 rounded-full w-8 h-8 flex items-center justify-center font-bold hover:bg-red-200 transition-colors shadow-sm';
                removeBtn.innerHTML = 'X';
                removeBtn.onclick = () => newEntry.remove();
                newEntry.appendChild(removeBtn);
            }

            childrenList.appendChild(newEntry);
        });
    }

    // Input Masks
    const cpfInput = document.getElementById('cpf');
    if (cpfInput) {
        cpfInput.addEventListener('input', function (e) {
            let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
            if (value.length > 11) value = value.slice(0, 11);
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
            e.target.value = value;
        });
    }

    const phoneInput = document.getElementById('phone');
    if (phoneInput) {
        phoneInput.addEventListener('input', function (e) {
            let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
            if (value.length > 11) value = value.slice(0, 11);
            value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
            value = value.replace(/(\d)(\d{4})$/, '$1-$2');
            e.target.value = value;
        });
    }

    // Real-time Validations
    if (cpfInput) {
        cpfInput.addEventListener('blur', function (e) {
            if (e.target.value && !isValidCPF(e.target.value)) {
                e.target.classList.add('border-red-500', 'focus:border-red-500', 'focus:ring-red-500');
            } else {
                e.target.classList.remove('border-red-500', 'focus:border-red-500', 'focus:ring-red-500');
            }
        });
    }

    const emailInput = document.getElementById('email');
    if (emailInput) {
        emailInput.addEventListener('blur', function (e) {
            if (e.target.value && !isValidEmail(e.target.value)) {
                e.target.classList.add('border-red-500', 'focus:border-red-500', 'focus:ring-red-500');
            } else {
                e.target.classList.remove('border-red-500', 'focus:border-red-500', 'focus:ring-red-500');
            }
        });
    }
});

let currentStep = 1;

function goToStep(step) {
    document.querySelectorAll('.step-content').forEach(el => el.classList.add('hidden'));
    document.querySelectorAll('.step-indicator').forEach(el => {
        el.classList.remove('active');
        el.classList.remove('text-brand-primary');
        el.classList.add('text-gray-400');
        el.setAttribute('aria-selected', 'false');
    });

    const target = document.getElementById(`step-${step}`);
    if (target) target.classList.remove('hidden');

    const indicator = document.getElementById(`ind-step-${step}`);
    if (indicator) {
        indicator.classList.remove('text-gray-400');
        indicator.classList.add('active');
        indicator.classList.add('text-brand-primary');
        indicator.setAttribute('aria-selected', 'true');
    }

    currentStep = step;

    // Mobile smooth scroll UX tweak to shift form to top
    const formSection = document.getElementById('form-section');
    if (formSection) {
        window.scrollTo({
            top: formSection.offsetTop - 20,
            behavior: 'smooth'
        });
    }
}

function nextStep(step) { goToStep(step); }
function prevStep(step) { goToStep(step); }

// Modal Logic — Terms with Tabs
const termsTabRead = { privacidade: false, garantia: false };

function openTerms() {
    const modal = document.getElementById('modalTerms');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';

    // Reset state every time modal opens
    termsTabRead.privacidade = false;
    termsTabRead.garantia = false;
    document.getElementById('btnAcceptTerms').setAttribute('disabled', 'true');
    document.getElementById('checkPrivacidade').textContent = '○';
    document.getElementById('checkPrivacidade').className = 'text-gray-300';
    document.getElementById('checkGarantia').textContent = '○';
    document.getElementById('checkGarantia').className = 'text-gray-300';
    document.getElementById('termsHint').textContent = 'Leia as duas abas até o final para aceitar.';

    // Switch to first tab
    switchTermsTab('privacidade');

    // Check if content is short enough not to need scroll
    setTimeout(() => {
        const panel = document.getElementById('termsPanelPrivacidade');
        if (panel) checkTermsTabScroll(panel, 'privacidade');
    }, 120);
}

function closeTerms() {
    const modal = document.getElementById('modalTerms');
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.body.style.overflow = '';
}

window.switchTermsTab = function (tab) {
    const panels = { privacidade: 'termsPanelPrivacidade', garantia: 'termsPanelGarantia' };
    const tabs = { privacidade: 'tabPrivacidade', garantia: 'tabGarantia' };

    Object.keys(panels).forEach(key => {
        const panel = document.getElementById(panels[key]);
        const btn = document.getElementById(tabs[key]);
        if (key === tab) {
            panel.classList.remove('hidden');
            btn.classList.add('border-brand-primary', 'text-brand-primary');
            btn.classList.remove('border-transparent', 'text-gray-400');
        } else {
            panel.classList.add('hidden');
            btn.classList.remove('border-brand-primary', 'text-brand-primary');
            btn.classList.add('border-transparent', 'text-gray-400');
        }
    });

    // After switching, check if newly visible panel is scrollable
    setTimeout(() => {
        const panel = document.getElementById(panels[tab]);
        if (panel) checkTermsTabScroll(panel, tab);
    }, 80);
};

window.checkTermsTabScroll = function (el, tab) {
    const reached = el.scrollHeight - Math.round(el.scrollTop) - el.clientHeight <= 8;
    if (reached && !termsTabRead[tab]) {
        termsTabRead[tab] = true;
        const checkEl = document.getElementById('check' + tab.charAt(0).toUpperCase() + tab.slice(1));
        if (checkEl) {
            checkEl.textContent = '●';
            checkEl.className = 'text-green-500';
        }
        _maybeUnlockTerms();
    }
};

function _maybeUnlockTerms() {
    if (termsTabRead.privacidade && termsTabRead.garantia) {
        document.getElementById('btnAcceptTerms').removeAttribute('disabled');
        const hint = document.getElementById('termsHint');
        if (hint) {
            hint.textContent = 'Você leu os dois documentos. Pode aceitar abaixo.';
            hint.className = 'text-xs text-green-600 text-center mb-3 font-semibold';
        }
    } else {
        const hint = document.getElementById('termsHint');
        if (hint) {
            const remaining = !termsTabRead.privacidade && !termsTabRead.garantia
                ? 'Leia as duas abas até o final para aceitar.'
                : !termsTabRead.privacidade
                    ? 'Ainda falta ler: Política de Privacidade.'
                    : 'Ainda falta ler: Termos de Garantia.';
            hint.textContent = remaining;
        }
    }
}

function acceptTerms() {
    document.getElementById('terms').checked = true;
    clearTermsError();
    closeTerms();
}

// Validation Logic
function isValidCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
    let sum = 0, rest;
    for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    rest = (sum * 10) % 11;
    if ((rest === 10) || (rest === 11)) rest = 0;
    if (rest !== parseInt(cpf.substring(9, 10))) return false;
    sum = 0;
    for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    rest = (sum * 10) % 11;
    if ((rest === 10) || (rest === 11)) rest = 0;
    if (rest !== parseInt(cpf.substring(10, 11))) return false;
    return true;
}

function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
// --- Sinalização de erro do aceite de Termos -------------------
// Exibe/limpa a marcação visual e a mensagem de erro ao redor do checkbox
// de Termos (Passo 2), sem depender de elementos fixos no template.
const TERMS_ERROR_RING = ['ring-2', 'ring-red-400', 'rounded-lg'];

function showTermsError() {
    const termsInput = document.getElementById('terms');
    if (!termsInput) return;
    const termsLabel = termsInput.closest('label') || termsInput.parentElement;

    if (termsLabel) termsLabel.classList.add(...TERMS_ERROR_RING);

    let termsError = document.getElementById('termsError');
    if (!termsError) {
        termsError = document.createElement('p');
        termsError.id = 'termsError';
        termsError.className = 'text-red-500 font-semibold text-sm mt-1';
        (termsLabel || termsInput).insertAdjacentElement('afterend', termsError);
    }
    termsError.textContent = 'Para concluir o registro, é necessário aceitar os Termos de Privacidade e Condições.';
    termsError.classList.remove('hidden');
}

function clearTermsError() {
    const termsInput = document.getElementById('terms');
    const termsLabel = termsInput ? (termsInput.closest('label') || termsInput.parentElement) : null;
    if (termsLabel) termsLabel.classList.remove(...TERMS_ERROR_RING);
    const termsError = document.getElementById('termsError');
    if (termsError) termsError.classList.add('hidden');
}
// --------------------------------------------------------------------

// --- Validação obrigatória dos campos do Passo 2 (Seus Dados) ---
// Celular BR válido: 10 (fixo) ou 11 (celular) dígitos, considerando o DDD.
// Bloqueia vazio e números parciais (ex.: "(11) 9").
function isValidPhoneBR(phone) {
    const digits = (phone || '').replace(/\D/g, '');
    return digits.length === 10 || digits.length === 11;
}

// Valida Nome, Sobrenome, CPF, Celular e E-mail de uma vez. Destaca em
// vermelho os campos inválidos, mostra um resumo no topo do Passo 2 e
// retorna { ok, firstInvalid } (para foco no primeiro campo com erro).
function validateStep2() {
    const checks = [
        { id: 'first_name', valid: v => v.trim().length > 0, msg: 'Informe o Nome.' },
        { id: 'last_name',  valid: v => v.trim().length > 0, msg: 'Informe o Sobrenome.' },
        { id: 'cpf',        valid: v => isValidCPF(v),       msg: 'Informe um CPF válido.' },
        { id: 'phone',      valid: v => isValidPhoneBR(v),   msg: 'Informe um Celular válido com DDD.' },
        { id: 'email',      valid: v => isValidEmail(v),     msg: 'Informe um E-mail válido.' }
    ];

    const errors = [];
    let firstInvalid = null;

    checks.forEach(c => {
        const el = document.getElementById(c.id);
        if (!el) return;
        if (c.valid(el.value || '')) {
            el.classList.remove('border-red-500', 'focus:border-red-500', 'focus:ring-red-500');
        } else {
            el.classList.add('border-red-500', 'focus:border-red-500', 'focus:ring-red-500');
            errors.push(c.msg);
            if (!firstInvalid) firstInvalid = el;
        }
    });

    if (errors.length) showStep2Error(errors);
    else clearStep2Error();

    return { ok: errors.length === 0, firstInvalid };
}

function showStep2Error(messages) {
    const step2 = document.getElementById('step-2');
    if (!step2) return;
    let box = document.getElementById('step2Error');
    if (!box) {
        box = document.createElement('div');
        box.id = 'step2Error';
        box.className = 'bg-red-50 text-red-600 border border-red-200 font-semibold text-sm p-3 rounded-lg';
        step2.insertAdjacentElement('afterbegin', box);
    }
    box.innerHTML = messages.map(m => '• ' + m).join('<br>');
    box.classList.remove('hidden');
}

function clearStep2Error() {
    const box = document.getElementById('step2Error');
    if (box) box.classList.add('hidden');
}
// ------
function submitForm(e) {
    e.preventDefault();

    // Passo 1 (seleção de produto) é obrigatório. Mesmo que o usuário navegue
    // livremente pelas abas e chegue ao submit sem produto (ou com cor/selo
    // faltando), reaproveitamos a validação do Passo 1: se falhar, a mensagem
    // de erro é exibida e o usuário é devolvido para a aba "Seu Produto".
    if (typeof validateStep1 === 'function' && !validateStep1(false)) {
        goToStep(1);
        return;
    }

    // Passo 2 (Seus Dados): campos obrigatórios + aceite de Termos.
    // Todos os campos abaixo pertencem à aba "Seus Dados"; se algo faltar/for
    // inválido, devolvemos o usuário ao Passo 2, destacamos os campos e
    // interrompemos o envio.
    const formFeedback = document.getElementById('submitFeedback');
    const btnSubmit = document.getElementById('btnSubmit');

    if (formFeedback) {
        formFeedback.classList.add('hidden');
        formFeedback.className = 'absolute -top-12 left-0 right-0 font-bold text-sm text-center hidden p-3 rounded-lg border';
    }

    // Nome, Sobrenome, CPF, Celular e E-mail
    const step2 = validateStep2();

    // Aceite de Termos é obrigatório (consentimento LGPD). O checkbox só é
    // marcado pelo modal de aceite; quem pula o Passo 2 pelas abas chega aqui
    // com ele desmarcado.
    const termsInput = document.getElementById('terms');
    const termsOk = !!(termsInput && termsInput.checked);
    if (termsOk) clearTermsError(); else showTermsError();

    if (!step2.ok || !termsOk) {
        goToStep(2);
        const focusEl = step2.firstInvalid || (!termsOk ? termsInput : null);
        if (focusEl && typeof focusEl.focus === 'function') focusEl.focus();
        return;
    }

    // Build Payload
    const form = document.getElementById('registrationForm');
    const formData = new FormData(form);
    // Extract configured brand from initial JS config
    const brandName = window.currentBrand ? window.currentBrand.brand_name : 'N/A';

    const customer = {
        first_name: formData.get('first_name'),
        last_name: formData.get('last_name'),
        document: formData.get('cpf') ? formData.get('cpf').replace(/\D/g, '') : '',
        email: formData.get('email'),
        phone: formData.get('phone') ? formData.get('phone').replace(/\D/g, '') : '',
        opt_in: formData.get('opt_in') === 'on',
        origin: brandName,
        order_id: "",
        terms_accepted: formData.get('terms') === 'on'
    };

    // Extract selected products from the hidden field
    let products = [];
    const productsJson = formData.get('selected_products_json');
    if (productsJson && productsJson !== '[]') {
        try {
            const arr = JSON.parse(productsJson);
            products = arr.map(p => {
                const validItems = Array.isArray(p.items) ? p.items : [];
                const selectedItem = (p.selectedColorIndex !== null && validItems[p.selectedColorIndex]) ? validItems[p.selectedColorIndex] : (validItems.length > 0 ? validItems[0] : null);
                return {
                    sku: selectedItem && selectedItem.sku ? selectedItem.sku : p.reference,
                    brand: brandName,
                    name: p.name,
                    category: p.category || 'Geral',
                    warranty_code: p.warrantyCode || "",
                    order_id: ""
                };
            });
        } catch (e) { }
    }

    // Extract children logic
    const isGift = formData.get('is_gift') === 'yes';
    const knowsChild = formData.get('knows_child') === 'yes';
    let children = [];

    if (!isGift || (isGift && knowsChild)) {
        const childNames = formData.getAll('child_name[]');
        const childBirths = formData.getAll('child_birth[]');
        const childGenders = formData.getAll('child_gender[]');

        for (let i = 0; i < childNames.length; i++) {
            if (childNames[i] || childBirths[i]) {
                children.push({
                    name: childNames[i],
                    birth_date: childBirths[i],
                    gender: childGenders[i]
                });
            }
        }
    }

    const payload = {
        customer,
        children,
        products
    };

    const loader = document.getElementById('globalLoader');
    if (loader) loader.classList.remove('hidden');
    if (btnSubmit) {
        btnSubmit.disabled = true;
        btnSubmit.innerHTML = `<svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Enviando...`;
    }

    // Actual network request
    fetch('https://dorel.app.n8n.cloud/webhook/product-registration', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
        .then(async response => {
            if (loader) loader.classList.add('hidden');
            if (btnSubmit) {
                btnSubmit.disabled = false;
                btnSubmit.innerHTML = `Concluir Registro`;
            }

            if (!response.ok) {
                throw new Error(`Erro do servidor: ${response.status}`);
            }

            if (formFeedback) {
                formFeedback.textContent = "Registro submetido com sucesso!";
                formFeedback.className = 'absolute -top-12 left-0 right-0 font-bold text-sm text-center p-3 rounded-lg border bg-green-50 text-green-800 border-green-200';
            }

            if (typeof clearFormState === 'function') clearFormState();
            document.getElementById('registrationForm').reset();

            if (typeof window.clearSelectedProducts === 'function') {
                window.clearSelectedProducts();
            }

            setTimeout(() => {
                goToStep(1);
                if (formFeedback) formFeedback.classList.add('hidden');
            }, 3000);
        })
        .catch(error => {
            if (loader) loader.classList.add('hidden');
            if (btnSubmit) {
                btnSubmit.disabled = false;
                btnSubmit.innerHTML = `Tentar Novamente`;
            }

            if (formFeedback) {
                formFeedback.textContent = "Falha de conexão. Por favor, tente novamente.";
                formFeedback.className = 'absolute -top-12 left-0 right-0 font-bold text-sm text-center p-3 rounded-lg border bg-red-50 text-red-600 border-red-200';
            }
        });
}
